module.exports = __webpack_public_path__ + "img/55.f1842f22.jpg";